export {default as path} from "./path.js";



//////////////////
// WEBPACK FOOTER
// ./~/d3-path/src/index.js
// module id = ./node_modules/d3-path/src/index.js
// module chunks = 54